import { ShieldCheck, Star, MapPin, Headphones } from "lucide-react";

const FEATURES = [
  {
    icon: ShieldCheck,
    title: "Verified MedSpas",
    text: "All listings are verified for your safety",
  },
  {
    icon: Star,
    title: "Top Rated Providers",
    text: "Read reviews and compare providers",
  },
  {
    icon: MapPin,
    title: "Find Local Providers",
    text: "Discover med spas near you in seconds",
  },
  {
    icon: Headphones,
    title: "Trusted Support",
    text: "Helpful resources every step of the way",
  },
];

export default function HeroFeatures() {
  return (
    <div className="grid grid-cols-2 lg:grid-cols-4 gap-x-6 gap-y-8">
      {FEATURES.map(({ icon: Icon, title, text }) => (
        <div key={title}>
          <div className="w-12 h-12 rounded-full grid place-items-center bg-primary/10 border border-primary/20 text-primary mb-4">
            <Icon className="w-5 h-5" />
          </div>
          <h3 className="text-sm font-semibold text-foreground mb-1.5">
            {title}
          </h3>
          <p className="text-sm leading-snug text-muted-foreground">{text}</p>
        </div>
      ))}
    </div>
  );
}
